module.exports = __webpack_public_path__ + "static/media/26.920fd188.jpg";